<template>
  <section>
    <div class="d-flex justify-content-between">
      <h5 class="font-weight-bold">{{ info.title | i18n }}</h5>
    </div>
    <div v-for="entry in info.entries" :key="entry.key">
      <!-- Si la valeur est un groupe -->
      <div v-if="entry.length">
        <div>{{ entry[0].group | i18n }}</div>
        <div class="ml-2" v-for="subEntry in entry" :key="subEntry.key">
          <SoftwareDetailsEntry :entry="subEntry" />
        </div>
      </div>
      <!-- Sinon -->
      <SoftwareDetailsEntry v-else :entry="entry" />
    </div>
  </section>
</template>

<script>
import SoftwareDetailsEntry from "./SoftwareDetailsEntry.vue";
/**
 * @description Composante qui affiche un bloc d'informations
 * @author Samuel Dubé
 * @vue-prop {Object} info - Information à afficher
 */
export default {
  name: "SoftwareDetailsBloc",
  components: { SoftwareDetailsEntry },
  props: {
    info: {
      type: Object,
      required: true
    }
  }
};
</script>
